/*
 * @Author: 7
 * @Date: 2023-04-24 15:21:49
 * @LastEditTime: 2023-04-27 13:19:33
 * @FilePath: /sjtu-reference-canvas/src/axios.js
 */
/**
 * 添加教参编辑接口
 * 谢冉
 * 2020.8.25
 */
import axios from 'axios';
import { getParams, getToken } from './utils/store';

const token = getToken() || '';

const instance = axios.create({
  // baseURL: 'http://192.168.1.87:8080/sjtu/reference/canvas/', //  本地测试
  baseURL: process.env.REACT_APP_ENV === 'test' ? 'https://fsjst-fat.jiatu.cloud:38001/sjtu/reference/canvas/' : 'https://jc.sjtu.edu.cn/api/',
  // baseURL: 'https://jc.sjtu.edu.cn/api/', //  上交大服务正式
  // baseURL: 'https://fsjst-fat.jiatu.cloud:38001/sjtu/reference/canvas/', //  测试
  // baseURL: 'http://jiaocanzzylocal.free.idcfengye.com/sjtu/reference/canvas/', //  上交大服务测试
  // timeout: 1000,
  // headers: { 'X-Custom-Header': 'foobar' },
});
// 添加请求拦截器
instance.interceptors.request.use(
  function (config) {
    const params = JSON.parse(getParams());
    config.headers = {
      userId: params?.userId,
      courseId: params?.courseId,
      ghId: params?.ghId,
      isTeacher: params?.isTeacher,
      token,
    };
    // 在发送请求之前做些什么
    return config;
  },
  function (error) {
    // 对请求错误做些什么
    return Promise.reject(error);
  }
);

// 添加响应拦截器
instance.interceptors.response.use(
  response => {
    // 对响应数据做点什么
    return response;
  },
  error => {
    if (error?.response?.status === 401) {
      console.log('接口401', error?.response);
      const redirect = error?.response.headers['redirect'];
      window.location.href = redirect;

      // confirm({
      //   title: '用户未登录，是否重新登录?',
      //   icon: null,
      //   content: '',
      //   okText: '确认',
      //   cancelText: '取消',
      //   onOk() {
      //     console.log('OK');
      //   },
      //   onCancel() {
      //     console.log('确定');
      //   },
      // });
    }

    if (error?.response)
      // 对响应错误做点什么
      return Promise.reject(error);
  }
);
export { instance };
